import { AisSortBy } from 'vue-instantsearch';

export default {
  components: {
    AisSortBy,
  },
  props: {
    indexName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      toggleFilters: [
        { name: 'In Stock', value: 'in_stock' },
        { name: 'On Sale', value: 'on_sale' },
        { name: 'Ships Free', value: 'free_shipping' }
      ]
    }
  },
  computed: {
    sortOptions() {
      return [
        { value: this.indexName, label: 'Recommended' },
        { value: `${this.indexName}_created_at_timestamp_desc`, label: 'New Arrivals' },
        { value: `${this.indexName}_proper_name_asc`, label: 'Item Name: A-Z' },
        { value: `${this.indexName}_proper_name_desc`, label: 'Item Name: Z-A' },
        { value: `${this.indexName}_price_asc`, label: 'Price: Low to High' },
        { value: `${this.indexName}_price_desc`, label: 'Price: High to Low' }
      ]
    }
  }
}